document.addEventListener('DOMContentLoaded', () => {
    const accordionHeaders = document.querySelectorAll('.accordion-item-heading');

    accordionHeaders.forEach(header => {
        header.addEventListener('click', () => {
            const itemIdentifier = header.getAttribute('data-accordion-item-title');
            const content = document.querySelector(`[data-accordion-item-content="${itemIdentifier}"]`);

            if (!content) {
                console.warn(`No matching content found for header with data-accordion-item-title="${itemIdentifier}"`);
                return;
            }

            // Check if the clicked header is already active
            const isActive = header.classList.contains('is-active');

            // First, close all accordion items
            document.querySelectorAll('.accordion-item-content').forEach(item => {
                item.classList.remove('is-open');
                item.style.maxHeight = null;
            });

            document.querySelectorAll('.accordion-item-heading').forEach(item => {
                item.classList.remove('is-active');
            });

            // If the clicked item wasn't active before, open it
            // If it was already active, it will remain closed
            if (!isActive) {
                header.classList.add('is-active');
                content.classList.add('is-open');

                // Adjust the max-height of the content
                content.style.maxHeight = content.scrollHeight + 'px';
            }
            // If it was active, we've already closed it above, so do nothing more
        });
    });
});
